// bee.tsx
"use client";
import { motion, Variants } from "framer-motion";

const rightWingVariants: Variants = {
  flap: {
    rotate: [-4, 3, -5, 2, -3],
    x: [0, 0.5, -0.5, 0],
    transition: {
      duration: 0.04,
      repeat: Infinity,
      ease: "easeInOut",
    },
  },
};

const leftWingVariants: Variants = {
  flap: {
    rotate: [4, -3, 5, -2, 3],
    x: [0, -0.5, 0.5, 0],
    transition: {
      duration: 0.04,
      repeat: Infinity,
      ease: "easeInOut",
      delay: 0.03,
    },
  },
};
export const Bee = ({
  width = "180",
  height = "180",
}: {
  width?: string;
  height?: string;
  animation?: string | undefined;
  size?: number;
  className?: string;
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 210 297"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      className="text-yellow-400"
    >
      {/* Corpo */}
      <ellipse
        style={{ fill: "#f8b133", fillOpacity: 1, strokeWidth: 0.264583 }}
        cx="102.23367"
        cy="120.43892"
        rx="8.1969995"
        ry="7.8396196"
      />

      {/* Ala destra */}
      <g transform="translate(-9.0824274,-41.070242)">
        <motion.g variants={rightWingVariants} animate="flap">
          <path
            style={{ fill: "#f8b133", fillOpacity: 1, strokeWidth: 0.264583 }}
            d="m 126.99533,132.46029 c -5.07461,21.66467 -5.00955,21.53455 -5.00955,21.53455 l 21.79479,-4.74931 z"
          />
          <path
            style={{ fill: "#f8b133", fillOpacity: 1, strokeWidth: 0.264583 }}
            d="m 129.45446,124.67007 21.98978,21.89777 6.80855,-2.39219 -26.22212,-26.03811 z"
          />
          <path
            style={{ fill: "#e6471a", fillOpacity: 1, strokeWidth: 0.264583 }}
            d="m 135.80297,111.78903 28.79833,28.52231 4.14033,-5.33643 -27.60223,-27.41822 z"
          />
          <path
            style={{ fill: "#32a9de", fillOpacity: 1, strokeWidth: 0.264583 }}
            d="m 149.22315,105.47982 0.2367,-0.005 a 24.185065,24.185065 7.2785781 0 1 7.06919,0.90289 19.004018,19.004018 25.085873 0 1 5.36682,2.51239 22.583407,22.583407 43.911121 0 1 4.57182,4.40128 18.959057,18.959057 58.369571 0 1 2.84896,4.62541 16.408996,16.408996 74.154973 0 1 1.18936,4.19052 29.015042,29.015042 85.844885 0 1 0.30893,4.25245 v 1.11158 z"
          />
        </motion.g>
      </g>

      {/* Ala sinistra */}
      <g transform="rotate(-143.59746,56.850299,129.51006)">
        <motion.g variants={leftWingVariants} animate="flap">
          <path
            style={{ fill: "#f8b133", fillOpacity: 1, strokeWidth: 0.264583 }}
            d="m 38.069207,131.66059 c -5.07461,21.66467 -5.00955,21.53455 -5.00955,21.53455 l 21.79479,-4.74931 z"
          />
          <path
            style={{ fill: "#f8b033", fillOpacity: 1, strokeWidth: 0.264583 }}
            d="m 40.528337,123.87037 21.98978,21.89777 6.80855,-2.39219 -26.22212,-26.03811 z"
          />
          <path
            style={{ fill: "#e84c1f", fillOpacity: 1, strokeWidth: 0.264583 }}
            d="m 46.876847,110.98933 28.79833,28.52231 4.14033,-5.33643 -27.60223,-27.41822 z"
          />
          <path
            style={{ fill: "#34a8df", fillOpacity: 1, strokeWidth: 0.264583 }}
            d="m 60.297027,104.68012 0.04694,-9.8e-4 a 25.459231,25.459231 7.2785781 0 1 7.441622,0.95047 18.127069,18.127069 25.265747 0 1 5.11162,2.41251 24.5398,24.5398 44.183153 0 1 4.945116,4.80609 15.300028,15.300028 58.201703 0 1 2.310048,3.72597 21.140658,21.140658 74.218457 0 1 1.526332,5.40059 19.69598,19.69598 85.837046 0 1 0.210104,2.88662 v 1.81032 z"
          />
        </motion.g>
      </g>
    </svg>
  );
};
